__turbopack_context__.v({
  "container": "mGHPmq_container",
  "fullScreen": "mGHPmq_fullScreen",
  "noBlur": "mGHPmq_noBlur",
  "overlay": "mGHPmq_overlay",
});
